/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type LocationFilterSchemaMode = typeof LocationFilterSchemaMode[keyof typeof LocationFilterSchemaMode];


export const LocationFilterSchemaMode = {
  include: 'include',
  exclude: 'exclude',
} as const;
